<template>
  <div class="selectTeacher">
    <el-page-header @back="goback" content="待咨询" > </el-page-header>
    <el-card class="box-card">
      <AppointInfo :appoint="appoint"></AppointInfo>
    </el-card>
    <p class="text-center" style="color:rgb(48, 49, 51);margin-bottom:12px;">{{diff(appoint)}}</p>
    <div v-if="canCancel" style="text-align:center;"><el-button type="primary" round style="width: 30%;" @click="open" >取消预约</el-button></div>

    <p class="text-right">
      <el-link v-if="canCancel" type="danger" @click="reminderShow = true">温馨提示</el-link>
    </p>

    <Reminder v-if="reminderShow" @close-reminder="closeReminder"></Reminder>
    <el-dialog
      title="是否取消预约？"
      :visible.sync="cancelAppoint"
      width="100%"
      :show-close="false"
      class="cancelAppoint"
    >
      <el-input v-model="memo" placeholder="请输入取消的原因"></el-input>
      <span slot="footer">
        <el-button @click="cancelAppoint = false" round>取 消</el-button>
        <el-button type="primary" @click="cancelSchedule(appoint.id)" round>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HttpRequest from "@/utils/request";
import { diffAppointStart, diffDays } from "@/utils/date.js";
import { parseAppointStatus,getStatusClass } from "@/utils/status.js";
import AppointInfo from '@/components/appointInfo'
import Reminder from '../components/reminder.vue';
export default {
  components: {
    AppointInfo,
    Reminder,
  },
  data() {
    return {
      reminderShow: false,
      cancelAppoint: false,
      appoint: {},
      scheduleId: null,
      pathfrom: null,
      memo: '',
      //
      diffAppointStart,
      diffDays,
      parseAppointStatus,
      getStatusClass,
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  created() {
    if (this.$route.query.scheduleId) {
      this.scheduleId = this.$route.query.scheduleId;
      this.getSchedule();
    }
    else{
      this.$alert('请求url缺乏必须的参数',  {confirmButtonText: '确定',showClose: false,});
    }
    this.pathfrom = this.$route.query.pathfrom;
  },
  mounted() {
    document.title = '预约详情'
  },
  methods: {
    open() {
      this.$confirm('取消预约后系统将会记录异常，如果多次取消预约，可能会导致系统无法正常使用。确定取消本次预约？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cancelAppoint = true
      }).catch(() => {
      });
    },
    goback() {
      // this.$router.back();
      this.$router.push("appointView");
    },
    getSchedule(){
      let url = "/constub/getSchedule";
      let data = { token: this.student.token, scheduleId: this.scheduleId };
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.appoint = res.data;
          if(this.appoint.status != 20 && this.appoint.status != 40){  //判断状态是否正确
            this.$message({message: '预约状态已变更，跳转回原路径',type: "error",});
            this.$router.push(this.pathfrom?this.pathfrom:'home')
          }
        } else {
          this.$alert(res.result.message,  {
            confirmButtonText: '确定',
            showClose: false,
          });
        }
      });
    },
    cancelSchedule(scheduleId) {
      let url = "/constub/cancelAppoint";
      let data = { token: this.student.token, scheduleId: scheduleId, memo: this.memo };
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.appoint = res.data;
          // this.$router.push({ name: "appointCancel", params: { appoint: this.appoint } });
          this.$message({message: '取消成功',type: "success"});
          this.$router.push('/appointCancel?scheduleId=' + scheduleId + (this.pathfrom?'&pathfrom=home':''))
        } else {
          this.cancelAppoint = false;  //关闭弹窗
          this.$alert(res.result.message,  {confirmButtonText: '确定',showClose: false,});
        }
      });
    },
    closeReminder(){
      this.reminderShow = false;
    },
    diff(appoint){
      let planDate = appoint.planDate;
      let planStartTime = appoint.planStartTime;
      var planTime = planDate + ' ' + planStartTime;
      let datePlan = new Date(planTime);
      let timePlan = datePlan.getTime();

      return  diffAppointStart(timePlan);
    },
    canCancel(){
      if (this.appoint.status==20){
        let dateNow = new Date();
        let datePlan = new Date(appoint.planDate);
        let diff = diffDays(dateNow,datePlan);
        return diff>1?true:false;
      }
      else
        return false
    }
  },
};
</script>


<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}

.title {
  width: 100%;
  padding: 10px;
  background-color: rgb(198, 212, 248);
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}
.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}
p {
  line-height: 24px;
}
.borderrd {
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
